export default [
    'hasBuffet',
    'hasHotel',
    'hasCanteen',
    'hasOfficeSpace',
    'hasCentralReception'
];
